var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiMakerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 895.8",
    enableBackground: "new 0 0 800 895.8",
    height: 25,
    className: "icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    fill: "#FFFFFF",
    d: "M423.4,80.9l62.5,18.6l19.9,65.5l18.4-64.1l63.4-19.7l-63.1-19.2L505,0l-18.9,62.7L423.4,80.9 M126.6,168.5 l79.6-24.7L127,119.6l-24.5-77.8l-23.8,78.7L0,143.4l78.5,23.4l25,82.3L126.6,168.5 M696.2,421.8l-23.8,78.8l-78.8,22.8 l78.6,23.5l25,82.4l23.1-80.6l79.7-24.8l-79.3-24.2L696.2,421.8 M527.8,458.8l-59.7-59.6C321,544.8,176,690.9,33,837.5 c0,0-0.1,0.1-0.2,0.2c-5,5.4-5,12.1,0.2,20l33.3,34.2c8.7,5.2,17.4,5.2,26.2,0C237.6,748.9,382.7,604.5,527.8,458.8 M689.6,202.6 c-7-4.9-14-5-21-0.4C612,257.3,555.8,312.5,499.8,367.8l59.5,59.5c54.6-54.9,109.1-109.9,163.6-165.2c7.1-8.7,7.1-17.4,0-26.1 L689.6,202.6 M375.3,254.1l-39.2-124.5l-38.1,126l-126,36.5l125.7,37.6l40,131.8l37-129L502.2,293L375.3,254.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiMakerIcon);
export default __webpack_public_path__ + "static/media/ai_maker_icon.f876bfa9.svg";
export { ForwardRef as ReactComponent };